import { Fragment, useState, useEffect } from 'react';

import { Dialog } from 'primereact/dialog';

import { WrongInvoiceService as Service } from './WrongInvoiceService';
import { LoadingService } from '../../../AppLoading';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { useSign } from '../../../shared/component/Sign';

import { DialogCrup } from './component/DialogCrup';
import { DialogViewTransferLog } from './component/DialogViewTransferLog';
import { DialogSendEmailRequire } from '../../hoa-don/component/DialogSendEmailRequire';
import EventEmitter from '../../../utils/EventEmitter';
import { Button } from 'primereact/button';
import { useTranslation } from '../../../shared/language';
export const List = () => {

  const { t } = useTranslation();
  const header = t('report.errorNoticeTitle');
  const dataKey = 'id';
  const [sendType, setSendType] = useState(4);
  const [displayCrup, setDisplayCrup] = useState(null);
  const [displayTransferLog, setDisplayTransferLog] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [pdf, setPdf] = useState(null);
  const [displayPdf, setDisplayPdf] = useState(null);

  const types = [
    { value: 1, translationKey: 'common.noticeFromTaxpayer' },
    { value: 2, translationKey: 'common.noticeFromTaxAuthority' }
  ];
  const statuses = [
    { value: 0, translationKey: 'common.notSubmitted' },
    { value: 1, translationKey: 'common.submitted' },
    { value: 2, translationKey: 'common.declarationSigned' }
  ];

  const feedbacks = [
    { value: 1, translationKey: 'common.received' },
    { value: 2, translationKey: 'common.notReceived' },
    { value: 3, translationKey: 'common.accepted' },
    { value: 4, translationKey: 'common.notAccepted' }
  ];

  const { render: renderDataTable, reloadLazyData, selectedItems, setSelectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'type', header: t('common.noticeType'), minWidth: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: types, dataType: 'fromFilterOptions' },
      { field: 'dateCreate', header: t('common.declarationDate'), width: 110, dataType: 'date' },
      {
        field: 'status', header: t('common.submissionStatus'), width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: statuses, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.status != 0) {
            return <span className={`underline ss04-status ss04-status-${rowData.status}`} onClick={() => setDisplayTransferLog(true)}>{t(statuses[rowData.status]?.translationKey || '')}</span>;
          } else {
            return <span className={`ss04-status ss04-status-${rowData.status}`}>{t(statuses[rowData.status]?.translationKey || '')}</span>;
          }
        }
      },
      {
        field: 'taxAuthorityFeedback', header: t('common.taxAuthorityFeedback'), width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: feedbacks, dataType: 'custom', customCell(rowData: any): any {
          if (typeof rowData.taxAuthorityFeedback === 'number') {
            return <span className={`underline ss04-feedback ss04-feedback-${rowData.taxAuthorityFeedback}`} onClick={() => setDisplayTransferLog(true)}>{t(feedbacks[(rowData.taxAuthorityFeedback - 1)]?.translationKey || '')}</span>;
          } else {
            return '';
          }
        }
      },
      { field: 'documentNo', header: t('common.noticeNumber'), width: 120, matchMode: 'contains' },
      { field: 'invoiceNo', header: t('common.invoiceNo'), minWidth: 160, matchMode: 'contains' },
      { field: 'dateSign', header: t('common.sentDate'), width: 100, dataType: 'date' },
      {
        field: 'print', header: t('common.printView'), width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-print" onClick={() => viewHtml(rowData)}></i>
        }, style: { justifyContent: 'center' }
      },
      {
        field: 'print', header: t('common.sendEmail'), width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="p-button-icon p-c pi pi-envelope" onClick={() => sendEmail(rowData)}></i>
        }, style: { justifyContent: 'center' }
      },
      {
        field: 'download', header: t('common.downloadXml'), width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-download" onClick={() => downloadXml(rowData)}></i>
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  const viewHtml = (rowData) => {
    Service.getHtmlUrl(rowData.id).then(data => {
      setPdf(data.masterPage);
    });
    setDisplayPdf(true);

    LoadingService.start();
  }

  const print = () => {
    const myWindow = window.open('') as Window;
    myWindow.document.open('text/plain');
    myWindow.document.write(pdf);
    myWindow.document.close();
    myWindow.onafterprint = () => myWindow.close();
    myWindow.print();
  };

  const onIframeLoad = () => {
    LoadingService.stop();
  }

  const downloadXml = (rowData) => {
    Service.downloadXml(rowData.id).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${rowData['taxCode']}_04_ss-HDDT.xml`;
      link.click();
    });
  }
  const sendEmail = (item) => {
    setSelectedItems(item);
    setDisplaySendEmail(true);
  }

  {/* useEffect(() => {
    const reloadData = () => {
      reloadLazyData
    }
    const eventsListner = EventEmitter.addListener("reloadInvoiceData", reloadData);
    return () => {
      eventsListner.removeListener("reloadInvoiceData", reloadData);
    }
  }); */}
  const { renderToolbar } = useToolbar({
    dataKey,
    create: () => {
      setSelectedItems(null);
      setDisplayCrup(true);
    },
    update: () => {
      setDisplayCrup(true);
    },
    // update,
    // clone,
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: t('common.signAndSend'), icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
          if (selectedItems && selectedItems['id']) {
            sign({
              "CommandName": "SignSS04",
              "Id": selectedItems['id']
            });
          }
        }
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderSign()}

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} selectedItem={selectedItems} reloadLazyData={reloadLazyData} />
      <DialogViewTransferLog display={displayTransferLog} setDisplay={setDisplayTransferLog} selectedItem={selectedItems} />
      <Dialog
        header={t('common.pdf')}
        visible={displayPdf}
        style={{ width: '80rem' }}
        position="top"
        onHide={() => setDisplayPdf(false)}
        icons={
          <div className="mr-2 grid">
            <div className="col-fixed p-0 pt-3 text-right" style={{ width: '510px' }}>
              <Button label={t('invoice.printInvoice')} icon="pi pi-print" onClick={print} className="p-button-outlined p-button-sm mr-2" />
            </div>
          </div>
        }
      >
        {pdf &&
          <iframe className="template-preview" srcDoc={pdf} title="pdf-preview" onLoad={onIframeLoad} style={{ height: '60rem' }} />
        }
      </Dialog>
      <DialogSendEmailRequire display={displaySendEmail} setDisplay={setDisplaySendEmail} sendType={sendType} selectedItems={selectedItems} />
    </Fragment>
  )
}
